<template>
	<v-flex xs12 class="background">
		<v-layout wrap align-center class="body-row">
			<v-flex
				text-xs-left
				class="row-height border-right"
				:class="{ 'bold': isOpen, 'px-4': item.level === 1, 'xs3': isEcuador, 'xs6': isPeru }"
				:style="isFolder ? `padding-left: calc(${item.level} * 25px)` : `color: #006edb; padding-left: 24px`"
				@click="toggle"
			>
				<span
					v-if="isFolder"
					class="mr-2"
					:class="{ 'pl-0': item.level === 1 }"
				>
					<v-btn icon class="ma-0 btn-action btn-auto">
						<v-icon color="success" size="18">
							<template v-if="isOpen">
								remove_circle_outline
							</template>
							<template v-else>
								add_circle_outline
							</template>
						</v-icon>
					</v-btn>
				</span>
				<span
					class="align-center"
					:class="{ 'pl-4': item.accountingAccountCode && !isFolder }"
					:style="!isFolder ? `color: #006edb; margin-left: calc(${item.level} * 17px)` : `margin-left: 4px`"
				>
					{{ item.account }} 
					<template v-if="isPeru">
						<span v-if="item.name.length < 70">{{ item.name }}</span>
						<v-tooltip top v-else>
							<span slot="activator">
								{{ item.name | limitTo(70) }}
							</span>
							<span>{{ item.name }}</span>
						</v-tooltip>
					</template>
				</span>
			</v-flex>
			<v-flex
				xs4
				text-xs-left
				class="row-height border-right"
				:class="{ 'bold': isOpen }"
				:style="!isFolder ? `color: #006edb; padding-left: 17px` : `padding-left: 17px`"
				v-if="isEcuador"
			>
				{{ item.name }}
			</v-flex>
			<v-flex
				text-xs-left
				class="row-height border-right"
				:class="{ 'bold': isOpen, 'xs3': isEcuador, 'xs4': isPeru }"
				:style="!isFolder ? `color: #006edb; padding-left: 17px` : `padding-left: 17px`"
			>
				<template>
					<span v-if="item.description.length < 50">{{ item.name }}</span>
					<v-tooltip top v-else>
						<span slot="activator">
							{{ item.description | limitTo(50) }}
						</span>
						<span>{{ item.description }}</span>
					</v-tooltip>
				</template>
			</v-flex>
			<v-flex xs2 class="row-height">
				<div class="collapse-menu">
					<v-menu>
						<v-btn dark icon slot="activator">
							<v-icon>more_horiz</v-icon>
						</v-btn>
						<v-list>
							<v-list-tile class="btn-menu-content">
								<v-list-tile-title class="menu-content" @click="$emit('add-account', item)">
									<img
									src="/static/img/icons/add-cuent.svg"
									alt="icon-add"
									width="15"
									height="15px">
									<span class="ml-1 text-action-blue">Agregar</span>
								</v-list-tile-title>
							</v-list-tile>
							<v-list-tile class="btn-menu-content" v-if="item.level > 1">
								<v-list-tile-title class="menu-content" @click="$emit('edit-account', item)">
									<img
										v-if="item.level > 1"
										src="/static/img/actions-list/edit.svg"
										alt="icon-edit"
										class="menu-option-icon"
										width="15px"
										height="15px"
									/>
									<span class="ml-1 text-edit-mobile">Editar</span>
								</v-list-tile-title>
							</v-list-tile>
							<v-list-tile class="btn-menu-content" @click="$emit('delete-account', item)" v-if="!isFolder">
								<img
									v-if="!isFolder"
									src="/static/img/actions-list/delete.svg"
									alt="icono"
									class="menu-option-icon"
									width="15px"
									height="15px"
								/>
								<span class="ml-1 text-delete-mobile">Eliminar</span>
							</v-list-tile>
						</v-list>
					</v-menu>
				</div>
				<!-- <app-tooltip-button
					icon="remove_red_eye"
					text="Ver Detalle"
					color="blue"
				></app-tooltip-button> -->
				<app-tooltip-button
					class="no-movil"
					icon="add_circle_outline"
					text="Agregar"
					color="blue"
					@click-icon="$emit('add-account', item)"
				></app-tooltip-button>
				<app-tooltip-button
					v-if="item.level > 1"
					class="no-movil"
					icon="edit"
					text="Editar"
					color="success"
					@click-icon="$emit('edit-account', item)"
				></app-tooltip-button>
				<app-tooltip-button
					v-if="!isFolder"
					class="no-movil"
					icon="delete"
					text="Eliminar"
					color="error"
					@click-icon="$emit('delete-account', item)"
				></app-tooltip-button>
			</v-flex>
			<v-layout wrap v-show="isOpen" v-if="isFolder">
				<tree-item
					class="item"
					v-for="(child, index) in item.details"
					:key="index"
					:item="child"
					@add-account="$emit('add-account', $event)"
					@edit-account="$emit('edit-account', $event)"
					@delete-account="$emit('delete-account', $event)"
					@row-expanded="$emit('row-expanded', $event)"
					@make-folder="$emit('make-folder', $event)"
					@add-item="$emit('add-item', $event)"
				></tree-item>
			</v-layout>
		</v-layout>
	</v-flex>
</template>
<script>
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	function isFolder() {
		return (this.item.flagParent && !this.item.details) ||
			(this.item.details && this.item.details.length > 0);
	}

	function makeFolder() {
		if (!this.isFolder) {
			this.$emit('make-folder', this.item);
			this.isOpen = true;
		}
	}

	function toggle() {
		if (this.isFolder) {
			if (!this.item.details) {
				this.$emit('row-expanded', this.item);
			}
			this.isOpen = !this.isOpen;
		}
	}

	function data() {
		return {
			isOpen: false,
		};
	}

	export default {
		name: 'tree-item',
		components: {
			appTooltipButton,
		},
		computed: {
			isFolder,
		},
		data,
		methods: {
			makeFolder,
			toggle,
		},
		props: {
			item: Object,
		},
	};
</script>

<style lang="scss" scoped>
	.body-row {
		background-color: #f4f6f8;
		color: map-get($colors, black);
		font-family: map-get($fonts, open-regular);
		font-size: map-get($sizes, small11);
	}

	.bold {
		font-family: map-get($fonts, open-bold);
	}

	.border-right {
		border-right: 1px solid map-get($colors, primary);
	}

	.row-height {
		border-bottom: 1px solid map-get($colors, primary);
		height: 30px;
		line-height: 28px;
		text-align: left;

		.align-center {
			vertical-align: top;
		}
	}

	.collapse-menu {
		display: none;

	@media (max-width: 768px) {
		align-items: center;
		display: block;
		grid-column: 4 / 5;
		grid-row: 1;
		height: 100%;
		justify-content: center;

		.v-menu {
				align-items: center;
				display: flex;
				height: 100%;
				justify-content: center;

			.v-btn {
				background-color: color(btn-green);
				height: 25px;
				margin: 0;
				width: 25px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/accounting-accounts/tree-item.vue